<div class="container">
  <H1>View Providers</H1>

  <div style="padding-top: 15px;width: 300px;text-align: left;">
    <label>Search:</label>
    <div class="input-group mb-3">
      <input class="form-control" ID="details" name="details" type="text" [(ngModel)]="SearchValue"
        placeholder="Type in something to search" />
      <div class="input-group-append">
        <button class="btn btn-outline-secondary btnClear" type="button" id="button-addon2"
          (click)="ClearSearch()">X</button>
      </div>
    </div>
    <div>
      <button class="btn btn-success" type="button" id="button-addon2"
        (click)="btnDownloadReportClickExcel()">Export</button>
      <button class="btn btn-primary" type="button" id="button-addon2" (click)="Add()"
        style="margin-left: 20px;">Add</button>
    </div>

  </div>


  <table class="viewDataTable" ID="tblData">
    <tr>
      <th class="viewDataTableHeading"></th>
      <th class="viewDataTableHeading">Providers Name</th>
      <th class="viewDataTableHeading">Direct Box Size</th>
      <th class="viewDataTableHeading">Direct Batch Size</th>
      <th class="viewDataTableHeading">Indirect Box Size</th>
      <th class="viewDataTableHeading">Indirect Batch Size</th>
    </tr>

    <tr *ngFor="let data of data | filter:SearchValue  | paginate: { itemsPerPage: ItemsPerPage, currentPage: p }">
      <td class="viewDataTableCell">
        <button type="submit" class="btn btn-primary btn-lg btn-block" ID="btnViewData"
          (click)="EditData(data.ID)">Edit</button>
      </td>
      <td class="viewDataTableCell">{{data.ID}}</td>
      <td class="viewDataTableCell">{{data.DirectBoxSize}}</td>
      <td class="viewDataTableCell">{{data.DirectBatchSize}}</td>
      <td class="viewDataTableCell">{{data.InDirectBoxSize}}</td>
      <td class="viewDataTableCell">{{data.InDirectBatchSize}}</td>
    </tr>

  </table>

  <pagination-controls (pageChange)="p = $event"></pagination-controls>

  <table class="viewDataTable" ID="tblDataExport" style="display: none;">
    <tr>
      <th class="viewDataTableHeading">Providers Name</th>
      <th class="viewDataTableHeading">Direct Box Size</th>
      <th class="viewDataTableHeading">Direct Batch Size</th>
      <th class="viewDataTableHeading">Indirect Box Size</th>
      <th class="viewDataTableHeading">Indirect Batch Size</th>
    </tr>

    <tr *ngFor="let data of data | filter:SearchValue">
      <td class="viewDataTableCell">{{data.ID}}</td>
      <td class="viewDataTableCell">{{data.DirectBoxSize}}</td>
      <td class="viewDataTableCell">{{data.DirectBatchSize}}</td>
      <td class="viewDataTableCell">{{data.InDirectBoxSize}}</td>
      <td class="viewDataTableCell">{{data.InDirectBatchSize}}</td>
    </tr>

  </table>




</div>